import { PaymentMethod } from '@/type';
import api from '@/billing/API';

export default {
  findAll(customerId: number): Promise<PaymentMethod[]> {
    return api
      .get(`customers/${customerId}/payment-methods`)
      .then(response => response.data);
  },
};
